import {OfferType} from "../../../types/OfferType";
import {normalizeListValue, normalizeScalarValue} from "./normalize_offer_listing_amplitude_query_value";
import {OfferListingItemListQuery, QueryValue} from "./types";

const DEFAULT_OFFER_TYPES = [OfferType.FLAT, OfferType.HOUSE];

export const getOfferListingAmplitudeItemListContextKey = (query: OfferListingItemListQuery, analyticsSessionId: string): string => {
    const contextParts = [
        `session:${analyticsSessionId}`,
        `type:${normalizeOfferTypes(query.type).join(",")}`,
        `region:${normalizeListValue(query.region).join(",")}`
    ];

    const country = normalizeScalarValue(query.country);
    const nearByOffer = normalizeScalarValue(query.near_by_offer);
    const vendor = normalizeScalarValue(query.vendor);
    const lat = normalizeScalarValue(query.lat);
    const lng = normalizeScalarValue(query.lng);

    if (country) {
        contextParts.push(`country:${country}`);
    }

    if (nearByOffer) {
        contextParts.push(`near_by_offer:${nearByOffer}`);
    }

    if (vendor) {
        contextParts.push(`vendor:${vendor}`);
    }

    if (lat || lng) {
        contextParts.push(`place:${lat ?? ""},${lng ?? ""}`);
    }

    return contextParts.join("|");
};

const normalizeOfferTypes = (type: QueryValue): string[] => {
    const offerTypes = normalizeListValue(type);

    if (offerTypes.length === 0) {
        return DEFAULT_OFFER_TYPES.map(String);
    }

    return offerTypes;
};
import {OfferType} from "../../../types/OfferType";
import {normalizeListValue, normalizeScalarValue} from "./normalize_offer_listing_amplitude_query_value";
import {OfferListingItemListQuery, QueryValue} from "./types";

const DEFAULT_OFFER_TYPES = [OfferType.FLAT, OfferType.HOUSE];

export const getOfferListingAmplitudeItemListContextKey = (query: OfferListingItemListQuery, analyticsSessionId: string): string => {
    const contextParts = [
        `session:${analyticsSessionId}`,
        `type:${normalizeOfferTypes(query.type).join(",")}`,
        `region:${normalizeListValue(query.region).join(",")}`
    ];

    const country = normalizeScalarValue(query.country);
    const nearByOffer = normalizeScalarValue(query.near_by_offer);
    const vendor = normalizeScalarValue(query.vendor);
    const lat = normalizeScalarValue(query.lat);
    const lng = normalizeScalarValue(query.lng);

    if (country) {
        contextParts.push(`country:${country}`);
    }

    if (nearByOffer) {
        contextParts.push(`near_by_offer:${nearByOffer}`);
    }

    if (vendor) {
        contextParts.push(`vendor:${vendor}`);
    }

    if (lat || lng) {
        contextParts.push(`place:${lat ?? ""},${lng ?? ""}`);
    }

    return contextParts.join("|");
};

const normalizeOfferTypes = (type: QueryValue): string[] => {
    const offerTypes = normalizeListValue(type);

    if (offerTypes.length === 0) {
        return DEFAULT_OFFER_TYPES.map(String);
    }

    return offerTypes;
};
